const getCardExpiryFormatted = (card) => card?.expire_month && card?.expire_year
    ? `${String(card.expire_month).padStart(2, '0')}/${card.expire_year}`
    : '-';
export default getCardExpiryFormatted;
